<template>
    <div class="card-container">
        <common-top-form
            selectShowPower="/lklexaminedetail/select"
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            :show="false"
        >
            <el-form-item label="代理商ID">
                <el-input
                    v-model="formModel.userId"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="formModel.status">
                    <el-option
                        v-for="item in status"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <!--<el-form-item label="类型">-->
                <!--<el-select v-model="formModel.isDeposit">-->
                    <!--<el-option-->
                        <!--v-for="item in types"-->
                        <!--:key="item.dictKey"-->
                        <!--:label="item.dictValue"-->
                        <!--:value="item.dictKey"-->
                    <!--&gt;-->
                    <!--</el-option>-->
                <!--</el-select>-->
            <!--</el-form-item>-->
            <el-form-item label="时间">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    range-separator="至"
                    :clearable="true"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column
                prop="userId"
                label="代理商ID"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="batchNo"
                label="批次号"
                :formatter="formatterTableData"
                min-width="200"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="status"
                label="状态"
                :formatter="formatStatus"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="type"
                label="类型"
                min-width="260"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                fixed="right"
                prop="createTime"
                label="操作时间"
                min-width="160"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column v-if="hasPerm('/lklexaminedetail/detail')" label="操作" min-width="100"
                             fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleDetail(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import TransactionService from "service/TransactionService";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "couponinfo",
        components: {
            CommonTopForm,
            CommonTable,
        },
        data() {
            return {
                formModel: {
                    userId: "",
                    status: "",
                    isDeposit: "",
                },
                status:[{
                    dictKey: '',
                    dictValue: '全部'
                },{
                    dictKey: '0',
                    dictValue: '处理中'
                },{
                    dictKey: '1',
                    dictValue: '完成'
                }],
                types:[{
                    dictKey: '',
                    dictValue: '全部'
                },{
                    dictKey: '0',
                    dictValue: '非押金版'
                },{
                    dictKey: '1',
                    dictValue: '押金版'
                }],
                tableData: [],
                submitService: TransactionService.lkldepositlist,
                params: {},
                page: {},
                isPage: false,
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.load();
        },
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == "") {
                    this.formModel.time = [];
                }
                const params = {
                    userId: this.formModel.userId,
                    status: this.formModel.status,
                    isDeposit: this.formModel.isDeposit,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.formModel.time.length) {
                    params.startDate = this.formModel.time[0];
                    params.endDate = this.formModel.time[1];
                }
                return params;
            },
            ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
        },
        methods: {
            load() {
                this.formModel = {
                    userId: "",
                    status: "",
                    isDeposit: "",
                };
                this.page = this.$refs.commonTable.page;
                this.getList();
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
            formatStatus(row, column, cellValue) {
                let value = "";
                this.status.forEach((item) => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value ? value : "--";
            },
            formatType(row, column, cellValue) {
                let value = "";
                this.types.forEach((item) => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value ? value : "--";
            },
            handleDetail(item){
                this.$router.push({
                    name: 'lklexaminedetaillist',
                    params: {
                        pId: item.id
                    }
                })
            }
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/LKLExamineDetail.vue